"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportedGHG = void 0;
var Tags_1 = require("../Tags");
var Card_1 = require("../Card");
var CardType_1 = require("../CardType");
var Resources_1 = require("../../Resources");
var CardName_1 = require("../../CardName");
var CardRenderer_1 = require("../render/CardRenderer");
var ImportedGHG = (function (_super) {
    __extends(ImportedGHG, _super);
    function ImportedGHG() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.IMPORTED_GHG,
            tags: [Tags_1.Tags.EARTH, Tags_1.Tags.SPACE],
            cost: 7,
            metadata: {
                cardNumber: '162',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.heat(1); }).heat(3);
                }),
                description: 'Increase your heat production 1 step and gain 3 heat.',
            },
        }) || this;
    }
    ImportedGHG.prototype.play = function (player) {
        player.addProduction(Resources_1.Resources.HEAT, 1);
        player.heat += 3;
        return undefined;
    };
    return ImportedGHG;
}(Card_1.Card));
exports.ImportedGHG = ImportedGHG;
//# sourceMappingURL=ImportedGHG.js.map